module.exports = __webpack_public_path__ + "media/old_images/icon-filter-active-5ca3828c.svg";